import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './_MatrixManagerBase.html?raw';

import MatrixGrid from './MatrixGrid';
import _uiFrameMixin from '../Container/uiFrame';

class _MatrixManagerBase<X = any, Y = any, Z = any> extends compose(_uiFrameMixin) {
	templateString: any = template;


	protected __matrixWidget: MdsLax<InstanceType<typeof MatrixGrid>>;
	protected __matrixGridContainer: HTMLElement;
	private __currentConfig: Matrix.Config<X, Y, Z>;
	private __dojoStartupDone: boolean = false;

	//
	protected onCallConfiguration(): boolean {
		// wird übersteuert in Kindklasse
		return false;
	}

	setup(config: Matrix.Config<X, Y, Z>) {

		if (!this.__matrixWidget) {
			this.__matrixWidget = new MatrixGrid();
			this.__matrixWidget.placeAt(this.__matrixGridContainer, "only");
			this.__matrixWidget.on("callConfig", lang.hitch(this, this.onCallConfiguration));
		}

		this.__currentConfig = config;
		this.__matrixWidget.setup(config);
	}


	postCreate(): void {
		super.postCreate.apply(this, arguments as any);

	}


	startup(): void {
		super.startup.apply(this, arguments as any);

		let footer = document.getElementById("mainFooter");
		if (footer) {
			let computedStyle = window.getComputedStyle(footer);

			let heightStr = computedStyle.height;
			let marginStr = computedStyle.marginTop;

			let footerHeight = parseInt(heightStr.replace('px', ''));
			let footerMargin = parseInt(marginStr.replace('px', ''));
		
			let height = footerHeight + footerMargin;
			let main = this.domNode;// document.getElementById("matrixMain");
			main.style.setProperty("--footerHeight", height + "px");
		}

		this.onCallConfiguration(); // startet mit Abfrage der Konfiguration

		this.__dojoStartupDone = true;

	}
}

export default mdsWidget(_MatrixManagerBase);